import { useContext } from "react";
import BatterySLD from "../SLD/BatterySLD";
import CircuitBreakerSVG from "../SLD/CircuitBreakerSVG";
import PowerMeterSVG from "../SLD/PowerMeterSVG";
import { DesignAssetContext } from "../../../pages/CustomHooks/ContextApi";
import DummyCB from "../SLD/DummyCB";
const index =2;
const Battery = () =>{
   const {
    CBAssetList,
  } = useContext(DesignAssetContext);
  const isPMRequired = CBAssetList[index]?.uiData?.pmRequired || false; 
  const isCBRequired = CBAssetList[index]?.uiData?.cbRequired || false;
    return (
        <svg className="pointer">
            <BatterySLD index={index}  x={500} y={140}/> 
        {   isPMRequired && <PowerMeterSVG
              id = {"_Battery"}
              x="505"
              y="127.5"
              index ={index}
            />}
       {  isCBRequired?   <CircuitBreakerSVG
              id={"_Battery"}
               x ={"600"}
              y ={"270"}
              index ={index}
              cbRequiredSelection = {true}
              name={CBAssetList[index]?.cbConfigData?.name || ""}
            />:
            <DummyCB   x ="635.5" y ="270"/>
            }
        </svg>
    );
}
export default Battery;